/**
 * Entry point for the React port of the portal frontend.
 *
 * Stage 0 mounts a shell and nothing else. It deliberately makes no API call:
 * the typed client and brand state land in stage 1, and a shell that fetches
 * before there is anything to render with would only add a failure mode the
 * parity harness would then have to tolerate.
 *
 * What this stage proves is the toolchain - that `web/` builds into
 * public/next/, that Express serves it at /next with the same middleware order
 * as "/", and that the browser smoke suite can drive both surfaces.
 *
 * @module web/main
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import { BrandProvider } from "./state/BrandContext.tsx";
import "./app.css";
import "./appearance.css";

const root = document.getElementById("root");
if (!root) throw new Error("no #root element - web/index.html was not the document that loaded this bundle");

createRoot(root).render(
  <StrictMode>
    <BrandProvider>
      <App />
    </BrandProvider>
  </StrictMode>,
);
